
export class TestingAccommodation {
  name?: string;
  displayName?: string;
  controlType?: string;
  dependency?: string;
  options?: string[];
  attributes?: Attribute[];
  parameters?: Parameter[];
  id?: string;
  isApplicable?: boolean;
  selectedValue?: string;
  displayId?: string;

  constructor(
    name?: string,
    attributes?: Attribute[],
    displayName?: string,
    controlType?: string,
    dependency?: string,
    options?: string[],
    parameters?: Parameter[],
    id?: string,
    isApplicable?: boolean,
    selectedValue?: string,
    displayId?: string
  ) {
    this.name = name;
    this.displayName = displayName;
    this.displayId = displayId;
    this.controlType = controlType;
    this.dependency = dependency;
    this.options = options;
    this.attributes = attributes;
    this.parameters = parameters;
    this.id = id;
    this.isApplicable = isApplicable;
    this.selectedValue = selectedValue;
    this.displayId = displayId;
  }
}
// made seperate classes if in future we would need to handle any addition/subtraction if any
// types of operands and value of duration to be added/subtracted based on operand
export class Parameter {
  name?: string;
  value?: string;
  selectedvalue?: string;

  constructor(
    name?: string,
    value?: string,
    selectedvalue?: string
  ) {
    this.name = name;
    this.value = value;
    this.selectedvalue = selectedvalue;
  }
}

// type of TA - Eg: Adjust duration
export class Attribute {
  name?: string;
  parameters?: Parameter[];

  constructor(
    name?: string,
    parameters?: Parameter[]
  ) {
    this.name = name;
    this.parameters = parameters;
  }
}
